/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardCreateRequest
 */
export interface DashboardCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof DashboardCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCreateRequest
     */
    portfolioKey: string;
    /**
     * 
     * @type {number}
     * @memberof DashboardCreateRequest
     */
    order: number;
}

/**
 * Check if a given object implements the DashboardCreateRequest interface.
 */
export function instanceOfDashboardCreateRequest(value: object): value is DashboardCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('portfolioKey' in value) || value['portfolioKey'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function DashboardCreateRequestFromJSON(json: any): DashboardCreateRequest {
    return DashboardCreateRequestFromJSONTyped(json, false);
}

export function DashboardCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'portfolioKey': json['portfolioKey'],
        'order': json['order'],
    };
}

export function DashboardCreateRequestToJSON(json: any): DashboardCreateRequest {
    return DashboardCreateRequestToJSONTyped(json, false);
}

export function DashboardCreateRequestToJSONTyped(value?: DashboardCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'portfolioKey': value['portfolioKey'],
        'order': value['order'],
    };
}

